import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {TIME_GAP_REQUEST_MS} from "../../../core/consts";

export class FullGameRequestParams extends BaseApiRequestParams {
  gameId: Number;
  matchupId: String;
  topBookmaker: Number

  constructor(gameId: Number, matchupId: String, topBookmaker: Number) {
    super('game/');

    this.gameId = gameId;
    this.matchupId = matchupId;
    this.topBookmaker = topBookmaker;
  }

  get gameIdParam() {
    return this.gameId  ? `&gameId=${this.gameId}` : '';
  }

  get matchupIdParam() {
    return this.matchupId  ? `&matchupId=${this.matchupId}` : '';
  }

  get topBookmakerParam() {
    return this.topBookmaker > 0 ? `&topBookmaker=${this.topBookmaker}` : '';
  }

  toString(): string {
    return super.toString() + this.gameIdParam + this.matchupIdParam + this.topBookmakerParam;
  }

  equals(model: FullGameRequestParams): Boolean {
    let equals = super.equals(model);

    equals &= this.gameIdParam === model.gameIdParam;
    equals &= this.topBookmakerParam === model.topBookmakerParam;

    if(!equals) {
      equals &= this.matchupIdParam === model.matchupIdParam;
    }

    return equals;
  }

  get timeGap(): Number {
    return TIME_GAP_REQUEST_MS.gameCenter
  }
}
